import { observer } from 'mobx-react';
import { action } from 'mobx';
import * as React from 'react';
import { inject } from '../../../utils/decorators';
import Callout from '../../site/Callout';
import VorgangFormularElement from '../VorgangFormularElement';
import DmgPruefortParameter from './DmgPruefortParameter';
import { bind } from '../../../utils/decorators';
import { VorgangStore } from '../../../stores/VorgangStore';
import { FormControl, Table, Panel, InputGroup, Checkbox, ControlLabel, Col, FormGroup } from 'react-bootstrap';
import KalibrierGegenstand from '../../../models/KalibrierGegenstand';
import { DmgKalibrierungStore } from '../../../stores/DmgKalibrierungStore';
import * as ApiTypes from '../../../models/ApiTypesDmg';

enum DmgArtMessung {
  Aufsteigend, Absteigend
}

export interface IDmgKalibrierungProps {
  elementguid: string;
  kategorieguid: string;
  editable?: boolean;
  value?: string;
  element: VorgangFormularElement;
}

interface IDmgMesspunktProps {
  ziel: ApiTypes.IDmgKalibrierungMesspunkt;
  editable: boolean;
  art: DmgArtMessung;
  schrittweite: number;
}

@observer
class DmgMesspunkt extends React.Component<IDmgMesspunktProps, {}> {

  @inject(DmgKalibrierungStore) store: DmgKalibrierungStore;

  @bind @action handleMesswertM1Changed(event: React.FormEvent<FormControl>) {
    const value = (event.target as HTMLInputElement).value !== '' ? (event.target as HTMLInputElement).valueAsNumber : null;
    const id = (event.target as HTMLInputElement).id;
    this.props.ziel.m1[id] = value;
  }

  @bind @action handleMesswertM2Changed(event: React.FormEvent<FormControl>) {
    const value = (event.target as HTMLInputElement).value !== '' ? (event.target as HTMLInputElement).valueAsNumber : null;
    const id = (event.target as HTMLInputElement).id;
    this.props.ziel.m2[id] = value;
  }

  render() {
    const { ziel, editable, schrittweite } = this.props;
    return (
      <tr>
        <td style={{textAlign: 'center'}}>{this.props.ziel.index}</td>
        <td>
          <InputGroup>
            <FormControl type="number" readOnly={true} value={this.props.ziel.nenndruck} tabIndex={-1}/>
            <InputGroup.Addon>bar</InputGroup.Addon>
          </InputGroup>
        </td>
        <td>
          {this.props.art === DmgArtMessung.Aufsteigend ?
            <FormControl type="number" step="0.1" id="normal" readOnly={!editable} onChange={(e) => this.handleMesswertM1Changed(e)} value={ziel.m1.normal !== null ? ziel.m1.normal : ''}/>
          :
            <FormControl type="number" step="0.1" id="normal" readOnly={!editable} onChange={(e) => this.handleMesswertM2Changed(e)} value={ziel.m2.normal !== null ? ziel.m2.normal : ''}/>
          }
        </td>
        <td>
          {this.props.art === DmgArtMessung.Aufsteigend ?
            <FormControl type="number" step={schrittweite} id="anzeige" readOnly={!editable} onChange={(e) => this.handleMesswertM1Changed(e)} value={ziel.m1.anzeige !== null ? ziel.m1.anzeige : ''}/>
          :
            <FormControl type="number" step={schrittweite} id="anzeige" readOnly={!editable} onChange={(e) => this.handleMesswertM2Changed(e)} value={ziel.m2.anzeige !== null ? ziel.m2.anzeige : ''}/>
          }
        </td>
      </tr>
    );
  }
}

interface IDmgKalibrierungHaltezeitProps {
  kalibrierGegenstand: KalibrierGegenstand | undefined;
}

@observer
class DmgKalibrierungHaltezeit extends React.Component<IDmgKalibrierungHaltezeitProps, {}> {

  @inject(DmgKalibrierungStore) store: DmgKalibrierungStore;

  @bind @action handleHaltezeitEingehaltenChange(ev: React.FormEvent<FormControl>) {
    this.store.setHalteZeitEingehalten((ev.target as HTMLInputElement).checked);
  }

  public render() {
    let haltezeit = 0;
    // Die Haltezeit hängt von der Art des Kalibriergegenstands ab
    if (this.props.kalibrierGegenstand) {
      let meta = this.props.kalibrierGegenstand.meta('anzeige');
      if (meta) {
        if (meta.indexOf('analog') > -1) {
          haltezeit = 5;
        } else if (meta.indexOf('digital') > -1) {
          haltezeit = 2;
        }
      }
    }
    return (
      <Callout bsStyle={this.store.datensatz.haltezeiteingehalten ? 'success' : 'danger'}>
        <Checkbox
          inline={true}
          disabled={this.store.readOnly}
          onChange={!this.store.readOnly ? this.handleHaltezeitEingehaltenChange : undefined}
          defaultChecked={this.store.datensatz.haltezeiteingehalten}
        >
          {haltezeit > 0 ? `Haltezeit von ${haltezeit.toString()} Minuten wurde eingehalten` : 'Haltezeit wurde eingehalten'}
        </Checkbox>
      </Callout>
    );
  }
}

@observer
class DmgKalibrierungVorbelastung extends React.Component<{}, {}> {

  @inject(DmgKalibrierungStore) store: DmgKalibrierungStore;

  @bind @action handleVorbelastungChange(ev: React.FormEvent<FormControl>) {
    this.store.setVorbelastungBisEndwert((ev.target as HTMLInputElement).checked);
  }

  public render() {
    return (
      <Callout bsStyle={this.store.datensatz.vorbelastungbisendwert ? 'success' : 'danger'}>
        <Checkbox
          inline={true}
          disabled={this.store.readOnly}
          onChange={!this.store.readOnly ? this.handleVorbelastungChange : undefined}
          defaultChecked={this.store.datensatz.vorbelastungbisendwert}
        >
          Vorbelastung bis Endwert wurde durchgeführt
        </Checkbox>
      </Callout>
    );
  }
}

interface IDmgKalibrierungKalibrierbereichProps {
  kalibrierGegenstand: KalibrierGegenstand | undefined;
}

@observer
class DmgKalibrierungKalibrierbereich extends React.Component<IDmgKalibrierungKalibrierbereichProps, {}> {

  @inject(DmgKalibrierungStore) store: DmgKalibrierungStore;

  @bind @action handleBisChange(ev: React.FormEvent<FormControl>) {
    this.store.setKalibrierbereich(this.store.datensatz.kalibrierbereich.von, (ev.target as HTMLInputElement).valueAsNumber);
  }

  public render() {
    const editable = !this.store.readOnly;
    if (!this.props.kalibrierGegenstand) {
      return null;
    }
    return (
      <Panel header="Kalibrierbereich" collapsible={true} defaultExpanded={true}>
        <FormGroup validationState={(this.store.datensatz.kalibrierbereich.von === null || this.store.datensatz.kalibrierbereich.bis === null) ? 'error' : undefined} style={{maxWidth: '80%', margin: 'auto'}}>
          <Col sm={3}componentClass={ControlLabel}>Kalibrierbereich</Col>
          <Col sm={4}>
            <InputGroup>
              <FormControl type="number" step="1" readOnly={true} id="kalibrierbereichvon" value={this.store.datensatz.kalibrierbereich.von !== null ? this.store.datensatz.kalibrierbereich.von : ''}/>
              <InputGroup.Addon>bar</InputGroup.Addon>
            </InputGroup>
          </Col>
          <Col sm={1} style={{paddingTop: '7px'}}>
            bis
          </Col>
          <Col sm={4}>
            <InputGroup>
              <FormControl type="number" step="1" readOnly={!editable} id="kalibrierbereichbis" value={this.store.datensatz.kalibrierbereich.bis !== null ? this.store.datensatz.kalibrierbereich.bis : ''} onChange={this.handleBisChange}/>
              <InputGroup.Addon>bar</InputGroup.Addon>
            </InputGroup>
          </Col>
        </FormGroup>
      </Panel>
    );
  }
}

interface IDmgKalibrierungObjektEigenschaftenProps {
  kalibrierGegenstand: KalibrierGegenstand | undefined;
}
@observer
class DmgKalibrierungObjektEigenschaften extends React.Component<IDmgKalibrierungObjektEigenschaftenProps, {}> {

  @inject(DmgKalibrierungStore) store: DmgKalibrierungStore;

  @bind @action handleZeigerArtChange(ev: React.FormEvent<FormControl>) {
    this.store.setZeigerArt((ev.target as HTMLInputElement).value);
  }

  public render() {
    const editable = !this.store.readOnly;
    if (!this.props.kalibrierGegenstand) {
      return null;
    }
    const doppelManometer = this.props.kalibrierGegenstand.objekt ? this.props.kalibrierGegenstand.objekt.name.toLocaleLowerCase().indexOf('doppelmanometer') > -1 : false;
    if (!doppelManometer) {
      return null;
    }
    return (
      <Panel header="Objekteigenschaften" collapsible={true} defaultExpanded={true}>
        <FormGroup validationState={this.store.datensatz.zeigerart === '' ? 'error' : undefined} controlId="zeigerart"  style={{maxWidth: '80%', margin: 'auto', marginBottom: '20px'}}>
          <Col componentClass={ControlLabel} sm={3}>Zeigerart</Col>
          <Col sm={8}>
            <FormControl componentClass="select" readOnly={!editable} placeholder="select" value={this.store.datensatz.zeigerart} onChange={this.handleZeigerArtChange}>
                <option value="">Bitte auswählen...</option>
                <option value="schwarz">Schwarzer Zeiger</option>
                <option value="rot">Roter Zeiger</option>
            </FormControl>
          </Col>
        </FormGroup>
      </Panel>
    );
  }
}

/** Messwerteingabe der Kalibrierung eines Druckmessgeräts */
@observer
export default class DmgKalibrierung extends React.Component<IDmgKalibrierungProps, {}> {

  @inject(VorgangStore) vorgangStore: VorgangStore;
  @inject(DmgKalibrierungStore) store: DmgKalibrierungStore;
  schrittweite: number = 0.1;

  kalibrierGegenstand: KalibrierGegenstand | undefined = undefined;

  constructor(props: IDmgKalibrierungProps) {
    super(props);
    this.store.clear();

    this.store.setReadOnly(this.props.editable ? !this.props.editable : true);
    // Zu betrachtendes DMG aus Auftrag ermitteln
    let vorgang = this.vorgangStore.vorgang;
    if (vorgang && vorgang.objekte) {
      for (var vgobj of vorgang.objekte) {
        if (vgobj.typ.toLocaleLowerCase() === 'dmg') {
          this.kalibrierGegenstand = new KalibrierGegenstand(vgobj);
          // Die Skalenteilung wird für die Schrittweite der Anzeigewerte verwendet
          let meta = this.kalibrierGegenstand.meta('skalenteilung');
          if (meta) {
              this.schrittweite = parseFloat(meta);
          }
          break;
        }
      }
    }

    // Gespeicherte Messung übernehmen
    if (this.props.value) {
      let messung: ApiTypes.IDmgKalibrierungDatensatz = this.store.datensatz;
      messung = JSON.parse(this.props.value) as ApiTypes.IDmgKalibrierungDatensatz;
      this.store.setMesswerte(messung);
    }

    // Wenn noch kein Kalibrierbereich gesetzt ist, wird dieser aus dem im Druckmessgerät angegebenen Messbereich übernommen
    if (this.kalibrierGegenstand && ((this.store.datensatz.kalibrierbereich.von === null) || (this.store.datensatz.kalibrierbereich.bis === null))) {
      let metaVon = this.kalibrierGegenstand.meta('messbereichvon');
      let metaBis = this.kalibrierGegenstand.meta('messbereichbis');
      if (metaVon || metaBis) {
        this.store.setKalibrierbereich(metaVon ? parseInt(metaVon, 10) : null, metaBis ? parseInt(metaBis, 10) : null);
      }
    }
  }

  public renderMessPunkte(art: DmgArtMessung) {
    if (art === DmgArtMessung.Aufsteigend) {
      return (
        this.store.datensatz.messpunkte.map((mp, index) =>
          <DmgMesspunkt key={index} ziel={mp} art={DmgArtMessung.Aufsteigend} editable={this.props.editable ? this.props.editable : false} schrittweite={this.schrittweite} />
        ));
    } else {
      return (
        this.store.datensatz.messpunkte.reverse().map((mp, index) =>
          <DmgMesspunkt key={index} ziel={mp} art={DmgArtMessung.Absteigend} editable={this.props.editable ? this.props.editable : false} schrittweite={this.schrittweite} />
        ));
    }
  }

  public renderMessReihe(art: DmgArtMessung) {
    let caption = art === DmgArtMessung.Aufsteigend ? 'Aufsteigend' : 'Absteigend';
    return (
      <Panel header={`Messung nach Ablauf C - ${caption}`} collapsible={true} defaultExpanded={true} className="dmg-eingabe-messwerte">
        <Table striped={false} bordered={false} condensed={true} hover={false} className="dmg-auswertung" style={{maxWidth: '80%', margin: 'auto', marginBottom: '20px'}}>
          <thead>
            <tr>
              <th>Messpunkt</th>
              <th>Nenndruck</th>
              <th>Normal</th>
              <th>Anzeige</th>
            </tr>
          </thead>
          <tbody>
            {this.renderMessPunkte(art)}
          </tbody>
        </Table>
      </Panel>
    );
  }

  public render() {
    if (!this.kalibrierGegenstand) {
      return (
        <Callout bsStyle="danger">
          <p>Für die Erstellung der Auswertung muss ein Druckmessgerät ausgewählt werden.</p>
        </Callout>
      );
    }
    return(
      <div>
        <DmgPruefortParameter
          titel="Prüfortparameter zu Beginn der Kalibrierung"
          ziel={this.store.datensatz.pruefortparameter.beginn}
        />
        <DmgKalibrierungObjektEigenschaften kalibrierGegenstand={this.kalibrierGegenstand}/>
        <DmgKalibrierungVorbelastung/>
        <DmgKalibrierungKalibrierbereich kalibrierGegenstand={this.kalibrierGegenstand}/>
        {this.renderMessReihe(DmgArtMessung.Aufsteigend)}
        <DmgKalibrierungHaltezeit kalibrierGegenstand={this.kalibrierGegenstand}/>
        {this.renderMessReihe(DmgArtMessung.Absteigend)}
        <DmgPruefortParameter
          titel="Prüfortparameter am Ende der Kalibrierung"
          ziel={this.store.datensatz.pruefortparameter.ende}
          referenz={this.store.datensatz.pruefortparameter.beginn}
        />
        {/* Kompletten Messdatensatz als verstecktes Feld im Request übergeben */}
        <FormControl type="hidden" name={`${this.props.kategorieguid}[${this.props.elementguid}][json]`} value={JSON.stringify(this.store.datensatz)}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/dmg/DmgKalibrierung.tsx